import React from 'react'

function EstadisticaMensual() {
  return (
    <div>
        <h1>Agosto: </h1>
        promedio: 731677
        <h2>Realizo: 22682000</h2>
        <h2>Gatos: 20972100</h2>
        <br />
        <h1>Septiembre:</h1>
        promedio: 743566
        <h2>Realizo:22307000</h2>
        <h2>Gastos:21507000</h2>
        <br/>
        <h1>Octubre:</h1>
        promedio: 705516
        <h2>Realizo:21871000</h2>
        <h2>Gastos:22311400</h2>

        <br />
        <h1>Noviembre:</h1>
        promedio: 708333
        <h2>Realizo:21250000</h2>
        <h2>Gastos:20987050</h2>

        <br />
        <h1>diciembre:</h1>
        promedio: 776225
        <h2>Realizo:24063000</h2>
        <h2>Gastos:24323250</h2>
        <br />
        <h1>enero:</h1>
        promedio: 781796
        <h2>Realizo:24235700</h2>
        <h2>Gastos:21604250</h2>

        <br />
        <h1>febrero:</h1>
        promedio: 861965 
        <h2>Realizo:24997000</h2>
        <h2>Gastos:23426100</h2>

        <br />
        <h1>marzo:</h1>
        promedio:912700
        <h2>Realizo: 28294000</h2>
        <h2>Gastos: 28130450</h2>
        acumulado anterior realizo 189644000
        gastos 183261600
        <br />
        <h1>abril:</h1>
        promedio: 979000
        <h2>Realizo: 29371000</h2>
        <h2>Gastos: 28828250</h2>
        acumulado anterior realizo 219015000
        gastos 212089850
        <br />
        <h1>mayo:</h1>
        promedio: 931000
        <h2>Realizo: 28866000</h2>
        <h2>Gastos: 31253850</h2>
        acumulado anterior realizo 247881000
        gastos 243253850
    </div>
  )
}

export default EstadisticaMensual